/**
 * Proactive, page-aware teaser bubbles for the launcher and quick-reply chips
 * that lower the friction of starting a conversation.
 *
 * Тон и темы — про операционку и модули WEBDAD OS, а не про заказ сайта
 * или разработку по часам (см. `model/systemPrompt.ts`).
 */

export type Teaser = {
  /** Substring matched against the current pathname; `null` = default/any page. */
  match: RegExp | null
  messages: string[]
}

const TEASERS: Teaser[] = [
  {
    match: /^\/os\/platform-as-a-service/,
    messages: [
      "Думаете, где разместить приложение? Помогу выбрать 🚀",
      "Расскажу, как устроен переезд на вашу инфраструктуру. Спросите!",
    ],
  },
  {
    match: /^\/os\/ai-business-assistant/,
    messages: [
      "Кстати, я и есть такой ассистент 🙂 Спросите, как это работает.",
      "Подскажу, какие вопросы клиентов можно отдать ассистенту.",
    ],
  },
  {
    match: /^\/os\/pulse/,
    messages: [
      "Расскажу, какие события можно снимать из ваших систем 📊",
      "Подскажу, с каких сигналов начинают. Спрашивайте!",
    ],
  },
  {
    match: /^\/os/,
    messages: [
      "Не знаете, с какого модуля начать? Помогу выбрать 👋",
      "Расскажите, что болит в процессах — подскажу, с чего начать.",
    ],
  },
  {
    match: /^\/projects/,
    messages: [
      "Похожая операционка у вас? Расскажу, как это устроено внутри 👀",
      "Спросите, что именно в этом проекте работает само.",
    ],
  },
  {
    match: /^\/store/,
    messages: [
      "Подскажу, какое приложение поставить и как оно свяжется с вашими системами ⚙️",
      "Расскажу, как это работает на вашем сервере. Спрашивайте!",
    ],
  },
  {
    match: null,
    messages: [
      "Привет! 👋 Помогу понять, что в вашей операционке может работать само.",
      "Заявки теряются или всё держится на одном человеке? Спросите — это ни к чему не обязывает 🙂",
      "Подскажу по автоматизации процессов, AI-ассистенту и своей инфраструктуре.",
    ],
  },
]

/** Returns the pool of teaser messages relevant to the given pathname. */
export function getTeasersForPage(pathname: string): string[] {
  const matched = TEASERS.find((t) => t.match && t.match.test(pathname))
  const fallback = TEASERS.find((t) => t.match === null)!
  return matched ? matched.messages : fallback.messages
}

/** Opening quick-reply chips shown on an empty chat to reduce friction. */
export const QUICK_REPLIES: string[] = [
  "Заявки теряются между каналами",
  "Всё держится на одном сотруднике",
  "С чего начать автоматизацию?",
  "Останутся ли данные у нас?",
]

export const GREETING =
  "Привет! Я Дэн, консультант по WEBDAD OS 👋 Расскажите, что в вашей операционке съедает больше всего времени — подскажу, что из этого может работать само. Это ни к чему не обязывает."
